import React from "react";
import { Outlet } from "react-router-dom";

function BrandDetailsComp() {
  return (
    <div>
      <Outlet />
    </div>
  );
}

export default BrandDetailsComp;
